{
  "orgSlug": "humentra",
  "name": "Humentra.AI",
  "logo": "/brand/logo-white.png",
  "logoClass": "h-6 w-auto sm:h-7",
  "favicon": "/brand/logo.png",
  "themeColor": "#060d1f",
  "fontsHref": "https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;700;800&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&family=IBM+Plex+Sans+Arabic:wght@400;500;600&family=Cairo:wght@600;700&display=swap"
}
